<template>
  <drop-down
    :items="data"
    :visibility="DropDownVisibility"
    :title="$t('title.setNavigationView')"
    :active-index="activeIndex"
    :data-test-id="{ testId }"
    @toggle-dropdown="handleDropDownVisibility"
  >
    <span :class="`${activeModeIndex === 1 ? 'icon-directions-fork' : 'icon-process_table'}`"></span>
  </drop-down>
</template>

<script>
import { ActiveCorners } from "../corner/CornerConstants";
import DropDown from "../../redZone/content/DropDown.vue";
import { icons } from "../../../utils/icons";
import { EditModes } from "../../../utils/constants";

export default {
  components: { DropDown },
  emits: ["toggle-drop-down"],
  data() {
    return {
      DropDownVisibility: false,
      ActiveCorners: ActiveCorners,
      data: [
        {
          id: 1,
          title: "Navigation Corner",
          icon: `${icons.Direction}`,
          func: this.setActiveCorner,
          testId: "navigation-corner",
        },
        {
          id: 2,
          title: "Data View",
          icon: `${icons.Grid}`,
          func: this.setDataView,
          testId: "data-view",
        },
      ],
    };
  },
  computed: {
    activeModeIndex() {
      return this.$store.state.views.activeCorner;
    },
    activeIndex() {
      return (this.$store.state.views.activeCorner ?? 0) === 0 ? 1 : 0;
    },
  },

  methods: {
    handleDropDownVisibility(visibility) {
      this.DropDownVisibility = visibility;
    },
    setActiveCorner() {
      this.$store.dispatch("pdesign/setEditMode", EditModes.Disable);
      this.$store.dispatch("views/setActiveCorner", 1);
    },
    setDataView() {
      this.$store.dispatch("pdesign/setEditMode", EditModes.Disable);
      this.$store.dispatch("views/setActiveCorner", 0);
    },
    callFunc() {
      this.DropDownVisibility = !this.DropDownVisibility;
    },
  },
};
</script>
